// @ts-nocheck


import sumBy from 'lodash/sumBy';
import isNil from 'lodash/isNil';
import shortId from 'shortid';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';







import {
  operationLimitAggregationFieldsEnum,
  operationLimitGroupStatusEnum } from
'./../../../../../../lib/enum';
import { withEmptyRow } from './../../../../../../lib/helpers';
import { declineHours } from './../../lib';
import { regulationLimitTypeEnum } from '../../../../../../lib/enum';
import {
  regulationLimitApi,
  regulationLimitGroupApi } from
'../../../../../../lib/api';

// Валидация лимитов
export const validateRegulationLimit = (
regulationLimit,
group) =>
{
  const errors = {};
  const { type, hours, hoursWeekend } = regulationLimit;
  const {
    hours: maxHours,
    hoursWeekend: maxHoursWeekend,
    usedInWeekends
  } = group;
  const getRequiredFields = () => {
    switch (type) {
      case regulationLimitTypeEnum.ovb:
        return ['ovbName', 'orgUnitId', 'hours', 'distance'];
      case regulationLimitTypeEnum.employee:
        return usedInWeekends ?
        [
        'jobTitleId',
        'distance',
        'hours',
        'hoursWeekend',
        'distanceWeekend'] :

        ['jobTitleId', 'distance', 'hours'];
      case regulationLimitTypeEnum.orgUnit:
      case regulationLimitTypeEnum.oneOffRequests:
        return usedInWeekends ?
        [
        'orgUnitId',
        'distance',
        'hours',
        'hoursWeekend',
        'distanceWeekend'] :

        ['orgUnitId', 'distance', 'hours'];
      default:
        return [];
    }
  };
  getRequiredFields().forEach((key) => {
    if (!regulationLimit[key]) errors[key] = 'Обязательное поле';
  });
  if (hours > maxHours) {
    errors.hours = `Время должно быть не более ${declineHours(maxHours)}`;
  }
  if (hoursWeekend > maxHoursWeekend) {
    errors.hoursWeekend = `Время должно быть не более ${declineHours(
      maxHours
    )}`;
  }
  return errors;
};

export const aggregateBy = (
limits,
key) =>
{
  return parseFloat(
    (
    sumBy(limits, key) / limits.filter((limit) => !isNil(limit[key])).length).
    toFixed(2)
  );
};

export const aggregateLimits = (
limits) =>
{
  return Object.keys(operationLimitAggregationFieldsEnum).reduce(
    (obj, key) => ({
      ...obj,
      [key]: aggregateBy(limits, key)
    }),
    {}
  );
};

/**
 * Функция конвертации строки к числу или к пустой строке
 * @param value Строка
 */
export const toStringNumberLimitValue = (value) =>
value.replace(/[^0-9.]/g, '') || '';

/**
 * Функция сохранения группы лимитов
 * @param group Группа
 * @param orgUnitId Прикрепляемое подразделение
 * @returns {Promise<void>}
 */
export const saveGroup = async (
group,
orgUnitId) =>
{
  group = {
    ...group,
    timeLimitStatus: operationLimitGroupStatusEnum.draft,
    assignmentLimitStatus: operationLimitGroupStatusEnum.draft
  };
  if (group.id) {
    await regulationLimitGroupApi.update(group);
  } else {
    group.orgUnitId = orgUnitId;
    const { id } = await regulationLimitGroupApi.add(group);
    group.id = id;
  }
  group.regulationLimits = await Promise.all(
    group.regulationLimits.map(async (limit) => {
      if (limit.id) {
        return await regulationLimitApi.update(limit);
      }
      limit.regulationLimitGroupId = group.id;
      // Только для должностных лиц проставляем orgUnitId
      // У остальных он проставляется в регламенте
      if (limit.type === regulationLimitTypeEnum.employee)
      limit.orgUnitId = group.orgUnitId;
      return await regulationLimitApi.add(limit);
    })
  );
  return group;
};

/**
 * Является ли число NaN или null, undefined
 * @param value Число
 * @returns {boolean}
 */
const isNilOrNaN = (value) => isNil(value) || isNaN(value);

/**
 * Возвращает массив лимитов с пустым лимитом на конце
 */
export const withEmptyLimit = (
limits,
group) =>
{
  const {
    id: regulationLimitGroupId,
    orgUnitId,
    type,
    hoursWeekend,
    hours,
    distance,
    distanceWeekend
  } = group;
  return withEmptyRow(limits, {
    emptyRow: {
      type,
      regulationLimitGroupId,
      hours: hours,
      distance,
      hoursWeekend: !isNilOrNaN(hoursWeekend) ? hoursWeekend : undefined,
      distanceWeekend: !isNilOrNaN(distanceWeekend) ?
      distanceWeekend :
      undefined,
      orgUnitId:
      type === regulationLimitTypeEnum.employee ? orgUnitId : undefined,
      key: shortId.generate()
    },
    ignoredEmptyRowKeys: ['key']
  });
};

/**
 * Проверяет пустой ли это лимит
 * @param limit Лимит
 * @param group Группа лимитов
 */
export const isEmptyLimit = (
limit,
group) =>
{
  const {
    id: regulationLimitGroupId,
    type,
    orgUnitId,
    hoursWeekend,
    hours,
    distance,
    distanceWeekend
  } = group;
  return isEqual(omit(limit, 'key'), {
    type,
    hours: hours,
    distance,
    hoursWeekend: !isNilOrNaN(hoursWeekend) ? hoursWeekend : undefined,
    distanceWeekend: !isNilOrNaN(distanceWeekend) ? distanceWeekend : undefined,
    orgUnitId:
    type === regulationLimitTypeEnum.employee ? orgUnitId : undefined,
    regulationLimitGroupId
  });
};
